import { get, orderBy } from 'lodash';
import EdcColumn from 'utility/generateHighChart/columnChart/EdcColumn.abstract';
import EdcChartDataGenerator from '../../../utility/chartData.transform';
import { CHART_TYPES } from '../../../utility/constant';

function queryResolutionTimeTransform(data) {
  const responseArray = get(data, 'values', []);
  const modifiedData = new EdcChartDataGenerator(
    responseArray,
    'count',
    CHART_TYPES.LOW_HIGH,
  ).generate();
  const groupCount = new EdcColumn('count');
  groupCount.yAxisLabel = 'Days from query creation to resolution';
  groupCount.xAxisLabel = 'Sites';
  const sortedData = orderBy(
    modifiedData,
    [
      (site) => get(site, 'data[0].y', null),
      (siteName) => get(siteName, 'siteName', null),
    ],
    ['desc', 'asc'],
  );
  const chartData = groupCount.generateChart(sortedData);
  return {
    chartData,
    cardList: get(data, 'cardList', []),
  };
}

export default queryResolutionTimeTransform;
